var map = {
	"./BAT-logo.png": 1217,
	"./BPT-logo.png": 1218,
	"./BUSD-logo.png": 1219,
	"./COMP-logo.png": 1220,
	"./CRV-logo.png": 1221,
	"./DAI-logo.png": 1222,
	"./ENJ-logo.png": 1223,
	"./ETH-logo.png": 1224,
	"./FTM-logo.png": 1225,
	"./KNC-logo.png": 1226,
	"./LEND-logo.png": 1227,
	"./LINK-logo.png": 1228,
	"./LRC-logo.png": 1229,
	"./MANA-logo.png": 1230,
	"./MKR-logo.png": 1231,
	"./REN-logo.png": 1232,
	"./REP-logo.png": 1233,
	"./SAI-logo.png": 1234,
	"./SNX-logo.png": 1235,
	"./SUSD-logo.png": 1236,
	"./TUSD-logo.png": 1237,
	"./USDC-logo.png": 1238,
	"./USDT-logo.png": 1239,
	"./YFI-logo.png": 1240,
	"./YFII-logo.png": 1241,
	"./ZRX-logo.png": 1242,
	"./aBAT-logo.png": 1243,
	"./aBUSD-logo.png": 1244,
	"./aDAI-logo.png": 1245,
	"./aETH-logo.png": 1246,
	"./aKNC-logo.png": 1247,
	"./aLEND-logo.png": 1248,
	"./aLINK-logo.png": 1249,
	"./aMANA-logo.png": 1250,
	"./aMKR-logo.png": 1251,
	"./aREP-logo.png": 1252,
	"./aSNX-logo.png": 1253,
	"./aSUSD-logo.png": 1254,
	"./aTUSD-logo.png": 1255,
	"./aUSDC-logo.png": 1256,
	"./aUSDT-logo.png": 1257,
	"./aWBTC-logo.png": 1258,
	"./aZRX-logo.png": 1259,
	"./cUSDC-logo.png": 1260,
	"./cUSDT-logo.png": 1261,
	"./curve.fi-logo.png": 1262,
	"./fUSD-logo.png": 1263,
	"./iDAI-logo.png": 1264,
	"./wBTC-logo.png": 1265,
	"./ycUSDC-logo.png": 1266,
	"./ycUSDT-logo.png": 1267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 496;